import React, { useState, useEffect } from "react";
import { getFormData } from "../../../helpers/formHelper";
import EditMedia from "../../uploads/EditMedia";
import ThankYouModal from "./../ThankYouModal";
import Modal from "../../Modal/Modal";
import ErrorList from "../../Errors/ErrorList";
import propTypes from "./propTypes";
import LoadingSpinner from "../../LoadingSpinner";
import { pleaseAddCommentText } from "../../../constants/errorMessages";
import { getErrors } from "../../../helpers/errorHelper";

export default function EditContributionModal(props) {
  const [commentText, setCommentText] = useState("");
  const {
    maxChars,
    errors,
    comment,
    dismissError,
    setPendingCommentSubmissionState,
    closeRootModal,
    resetSkipAndTop,
    handleCloseButtonClick,
    item,
    updateContribution,
    allowMapOnModal,
    setReloadComments
  } = props;

  useEffect(() => {
    comment.text !== null && setCommentText(comment.text);
  }, [comment.text]);

  // If there is an error we want to add a border around the offending element
  let errorList = {};
  if (props.pendingCommentSubmissionState === 'fail' && errors) {
    errorList = getErrors(errors);
  }

  function handleUserInput(input) {
    setCommentText(input.length < maxChars ? input : input.substring(0, maxChars));
  }

  function submitHandler(e) {
    e.preventDefault();
    // Clear the error
    dismissError();
    // Store all of the named fields in a formData object
    const formData = getFormData(e.target);
    const updatedComment = {
      ...comment,
      text: formData.Text,
      filenames: formData.filenames,
      uploadUrls: formData.uploadUrls,
      ImageDescriptions: formData.ImageDescriptions,
      ImageCaptions: formData.ImageCaptions,
      youtubeUrl: formData.YouTubeUrl,
    };
    updateContribution(updatedComment);
  }

  function handleThankYouClick() {
    setPendingCommentSubmissionState("");
    closeRootModal();
    resetSkipAndTop();
    setReloadComments(true);
  }

  return (
    <>
      {props.pendingCommentSubmissionState !== "success" && (
        <form className="ugc-contribution-modal ugc-contribution-modal--edit-container"
              onSubmit={submitHandler}>
          <h2 className="h3 ugc-contribution-modal--edit-container-title">Edit Contribution</h2>
          <div className="ugc-contribution-modal__form-content-wrapper">

            {
              props.pendingCommentSubmissionState === 'fail' && errors &&
              <ErrorList errors={errors}/>
            }

            {
              allowMapOnModal &&
              <div className="form-group ugc-contribution-modal--edit-map-on-modal">
                  <label className="h4 ugc-contribution-modal--edit-map-on-modal-label"
                       htmlFor="locationField">
                  <span className="icon icon--location"/>
                  Location
                </label>
                <input id="locationField"
                    className="form-control ugc-contribution-modal--edit-map-on-modal-location-field"
                       disabled="disabled"
                       type="text"
                       value={item.location.address}/>
              </div>
            }

            <div className="form-group">
              <label className="h4 ugc-contribution-modal--edit-comments-field-label"
                     htmlFor="commentsField">
                <span className="icon icon--comment-fill"/>
                {item.implementation.commentMessage}
              </label>

              {
                errorList.hasCommentError &&
                <div className="ugc-contribution-modal--edit-comments-field-error">
                  {pleaseAddCommentText}
                </div>
              }

              <textarea id="commentsField"
                className={`form-control ugc-contribution-modal--textarea ${errorList.hasCommentError ? 'border-error ugc-contribution-modal--textarea-error' : 'ugc-contribution-modal--textarea-default'}`}
                        rows="5"
                        name="Text"
                        placeholder="Enter your contribution..."
                        aria-describedby="comments-character-count"
                        value={commentText}
                        onChange={(e) => handleUserInput(e.target.value)}/>
              <div id="comments-character-count"
                className="ugc-contribution-modal--alias-character-count">
                {maxChars - commentText.length} characters left
              </div>
              {
                !comment.parentId &&
                <EditMedia
                  hasMediaError={errorList.hasMediaError}
                  hasYouTubeError={errorList.hasYouTubeError}
                  externalId={item.externalId}
                  uploadedMedia={comment.media}
                  allowVideo={item.implementation.allowVideo}
                  allowImages={item.implementation.allowImages}/>
              }
            </div>

            <div className="modal__buttons-wrapper ugc-contribution-modal--submit-button">
              <input type="submit"
                className="govuk-button he-button he-button__primary"
                     value="Submit my contribution"/>
              <button className="govuk-button he-button he-button__secondary"
                      onClick={e => handleCloseButtonClick(false, closeRootModal, dismissError, e)}>
                Cancel
              </button>

              {
                props.pendingCommentSubmission &&
                <LoadingSpinner/>
              }

            </div>
          </div>
        </form>
      )}

      {
        props.pendingCommentSubmissionState === "success" &&
        <Modal
          closeRootModal={handleThankYouClick}
          isSmallModal={true}>
          <ThankYouModal closeRootModal={handleThankYouClick}/>
        </Modal>
      }
    </>
  );
}

EditContributionModal.propTypes = propTypes;